/*
 * Prev/next buttons for the location photo strip.
 *
 * The strip is a native scroll-snap region and works completely without this
 * file: touch swipes, trackpads scroll, the tabindexed track arrow-keys. This
 * only adds clickable arrows for mouse users, where horizontal scrolling is
 * the one input that is genuinely awkward. So: inject buttons only when the
 * pointer is fine AND the track actually overflows, and if anything here
 * fails the strip is exactly what it was.
 */
class LocationGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.main-location__gallery-track');
    if (!this.track) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;
    // Layout may not be done at connect time; measure after a frame.
    requestAnimationFrame(() => {
      if (this.track.scrollWidth <= this.track.clientWidth + 8) return;
      this.addButtons();
    });
  }

  addButtons() {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mk = (dir, label) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = `main-location__gallery-nav main-location__gallery-nav--${dir}`;
      b.setAttribute('aria-label', label || dir);
      b.textContent = dir === 'prev' ? '‹' : '›';
      b.addEventListener('click', () => {
        const slide = this.track.querySelector('.main-location__gallery-slide');
        const step = slide ? slide.getBoundingClientRect().width : this.track.clientWidth * 0.8;
        this.track.scrollBy({
          left: dir === 'prev' ? -step : step,
          behavior: reduced ? 'auto' : 'smooth',
        });
      });
      this.appendChild(b);
      return b;
    };
    this.prev = mk('prev', this.track.dataset.prevLabel);
    this.next = mk('next', this.track.dataset.nextLabel);

    let raf = 0;
    const sync = () => {
      raf = 0;
      const max = this.track.scrollWidth - this.track.clientWidth - 4;
      this.prev.disabled = this.track.scrollLeft <= 4;
      this.next.disabled = this.track.scrollLeft >= max;
    };
    this.track.addEventListener('scroll', () => {
      if (!raf) raf = requestAnimationFrame(sync);
    }, { passive: true });
    sync();
  }
}

if (!customElements.get('location-gallery')) {
  customElements.define('location-gallery', LocationGallery);
}
